import React from 'react';
import { styled } from '@mui/material/styles';
import CustomButton from '../Button/Button';

const ButtonSection = styled('div')({
    display: 'flex',
    padding: '14px',
    '& .buttonLeft': {
        marginLeft: 'auto',
    },
    '& .buttonRight': {
        marginLeft: '15px',
    },
});

const ActionButtons = ({
    cancel,
    cancelColor = 'secondary',
    cancelText = 'Cancel',
    colorSubmit = 'primary',
    disabledCancel = false,
    disabledSubmit,
    size = 'medium',
    submit,
    submitText = 'OK',
}) => (
    <ButtonSection>
        <CustomButton
            className="buttonLeft"
            color={colorSubmit} size={size}
            disabled={disabledSubmit}
            onClick={submit}
            variant="contained"
        >
            {submitText}
        </CustomButton>
        <CustomButton
            className="buttonRight"
            color={cancelColor}
            disabled={disabledCancel}
            onClick={cancel}
            size={size}
            variant="contained"
        >
            {cancelText}
        </CustomButton>
    </ButtonSection>
);

export default ActionButtons;
